module.exports = __webpack_public_path__ + "static/media/newspaper.e4a67391.svg";